import { createContext, Dispatch, ReactElement, SetStateAction, useState } from "react";
import { UsuarioType } from "../types/UserTypes";

interface AppContextProps {
  authToken: string;
  setAuthToken: Dispatch<SetStateAction<string>>;
  userData: UsuarioType;
  setUserData: Dispatch<SetStateAction<UsuarioType>>;
  openSideBar: boolean;
  setOpenSiderBar: Dispatch<SetStateAction<boolean>>;
}

export const AppContext = createContext({} as AppContextProps);

export const AppContextProvider = ({ children }: { children: ReactElement }) => {
    const [openSideBar, setOpenSiderBar] = useState(false);
    const [authToken, setAuthToken] = useState<string>("");
    const [userData, setUserData] = useState<UsuarioType>({
        nome: "",
        email: "",
        bloquear_sistema: false,
    } as UsuarioType);

    return (
        <AppContext.Provider
            value={{
              authToken, 
              setAuthToken, 
              userData, 
              setUserData,
              openSideBar,
              setOpenSiderBar,
            }}
        >
            {children}
        </AppContext.Provider>
    );
};
